"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.encodeAxiomV2CircuitMetadata = void 0;
const viem_1 = require("viem");
const utils_1 = require("../utils");
const encodeAxiomV2CircuitMetadata = (params) => {
    // JS client overrides
    params.numChallenge = [0];
    params.isAggregation = false;
    const encodedVersion = (0, viem_1.encodePacked)(["uint8"], [params.version]);
    let encoded = (0, viem_1.concat)([encodedVersion]);
    const encodedNumValuesPerInstanceColumnLen = (0, viem_1.encodePacked)(["uint8"], [params.numValuesPerInstanceColumn.length]);
    const encodedNumValuesPerInstanceColumn = params.numValuesPerInstanceColumn.map((values) => (0, viem_1.encodePacked)(["uint32"], [values]));
    encoded = (0, viem_1.concat)([encoded, encodedNumValuesPerInstanceColumnLen, ...encodedNumValuesPerInstanceColumn]);
    const numPhase = params.numChallenge.length;
    if (numPhase === 0) {
        throw new Error("numChallenge must be non-empty");
    }
    const encodedNumPhase = (0, viem_1.encodePacked)(["uint8"], [numPhase]);
    const encodedNumChallenge = params.numChallenge.map((numChallenge) => (0, viem_1.encodePacked)(["uint8"], [numChallenge]));
    encoded = (0, viem_1.concat)([encoded, encodedNumPhase, ...encodedNumChallenge]);
    const encodedIsAggregation = (0, viem_1.encodePacked)(["bool"], [params.isAggregation]);
    encoded = (0, viem_1.concat)([encoded, encodedIsAggregation]);
    if (params.numAdvicePerPhase.length > numPhase) {
        throw new Error("numAdvicePerPhase must be <= numPhase (numChallenge.length)");
    }
    let numAdviceCols = params.numAdvicePerPhase;
    const resizedNumAdviceCols = (0, utils_1.resizeArray)(numAdviceCols, numPhase, 0);
    const encodedNumAdviceCols = resizedNumAdviceCols.map((adviceCols) => (0, viem_1.encodePacked)(["uint16"], [adviceCols]));
    encoded = (0, viem_1.concat)([encoded, ...encodedNumAdviceCols]);
    if (params.numLookupAdvicePerPhase.length > numPhase) {
        throw new Error("numLookupAdvicePerPhase must be <= numPhase (numChallenge.length)");
    }
    let numLookupAdviceCols = params.numLookupAdvicePerPhase;
    const resizedNumLookupAdviceCols = (0, utils_1.resizeArray)(numLookupAdviceCols, numPhase, 0);
    const encodedNumLookupAdviceCols = resizedNumLookupAdviceCols.map((lookupAdviceCols) => (0, viem_1.encodePacked)(["uint8"], [lookupAdviceCols]));
    encoded = (0, viem_1.concat)([encoded, ...encodedNumLookupAdviceCols]);
    const encodedNumRlcColumns = (0, viem_1.encodePacked)(["uint16"], [params.numRlcColumns]);
    const encodedNumFixed = (0, viem_1.encodePacked)(["uint8"], [params.numFixed]);
    const encodedMaxOutputs = (0, viem_1.encodePacked)(["uint16"], [params.maxOutputs]);
    encoded = (0, viem_1.concat)([encoded, encodedNumRlcColumns, encodedNumFixed, encodedMaxOutputs]);
    if (encoded.slice(2).length > 64) {
        throw new Error(`Circuit metadata cannot be packed into bytes32 (byte length=${encoded.slice(2).length / 2})`);
    }
    encoded = (0, viem_1.pad)(encoded, { size: 32, dir: "right" });
    return encoded;
};
exports.encodeAxiomV2CircuitMetadata = encodeAxiomV2CircuitMetadata;
//# sourceMappingURL=axiomV2CircuitMetadata.js.map